<app-pesquisa [(showDialog)]="pesquisarDialog" (pessoa)="loadData($event)"></app-pesquisa>

<app-relatorio-container
    tituloRelatorio="Requerimentos Diversos"
    descricaoRelatorio="Requerimento de serviços diversos - pessoa física"
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'requerimentos-diversos-medico.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6" [formGroup]="form">
            <p class="text-sm text-muted-color">Marque os objetos deste requerimento. O formulário será emitido para o médico selecionado (CRM/UF).</p>

            <app-card-medico-selecionado [pessoa]="pessoa()" [pessoaResponse]="pessoaResponse()" (alterar)="showPesquisarPessoa()"></app-card-medico-selecionado>

            <div class="field">
                <label class="font-semibold block mb-2">Objeto deste requerimento</label>
                <div class="flex flex-col gap-3">
                    @for (opcao of opcoes; track opcao.key) {
                        <div class="flex items-center gap-2">
                            <p-checkbox [formControlName]="opcao.key" [binary]="true" [inputId]="opcao.key"></p-checkbox>
                            <label [for]="opcao.key" class="cursor-pointer">{{ opcao.label }}</label>
                        </div>
                    }

                    <div class="flex items-center gap-2">
                        <p-checkbox formControlName="OUTROS" [binary]="true" inputId="OUTROS"></p-checkbox>
                        <label for="OUTROS" class="cursor-pointer">Outros:</label>
                        <input id="outrosTexto" type="text" pInputText formControlName="outrosTexto" class="flex-1" placeholder="Descreva (opcional)" />
                    </div>
                </div>
            </div>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button
                    label="Gerar Requerimento"
                    icon="pi pi-file-pdf"
                    [appCan]="roleGerar"
                    (click)="gerarRelatorio()"
                    [loading]="isPending"
                    [disabled]="isPending || !possuiPessoaSelecionada"
                    pTooltip="Para gerar o relatório, selecione um médico."
                    tooltipPosition="top"
                    [tooltipDisabled]="possuiPessoaSelecionada"
                ></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
